import { render, staticRenderFns } from "./satilanurunler.vue?vue&type=template&id=723a8e10&"
import script from "./satilanurunler.vue?vue&type=script&lang=js&"
export * from "./satilanurunler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports